export default __webpack_public_path__ + "static/media/closeModal.7b38a8cc.webp";